import { render, staticRenderFns } from "./detection-list.vue?vue&type=template&id=641211a2&"
import script from "./detection-list.vue?vue&type=script&lang=js&"
export * from "./detection-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports